'use strict';
import justlazy from '../justlazy/justlazy';

export default (tileDom) => {
    const tile = {};

    tile.domWrapper = {
        setWidth: (width) => {
            tileDom.style.width = `${width}px`;
            tileDom.style.minWidth = `${width}px`;
        },
        addLoaderClass: () => tileDom.getElementsByClassName('auction_cinema__image__spinner')[0].classList.add('p_loader250'),
        articleImagePlaceholderElement: () => tileDom.getElementsByClassName('auction_cinema__image_placeholder')[0],
        articleImageElement: () => tileDom.getElementsByTagName('img')[0],
        imageContainerElement: () => tileDom.getElementsByClassName('auction_cinema__image')[0],
        adsLinkElement: () => tileDom.getElementsByClassName('auction_cinema__adslink')[0],
        loaderBoxElement: () => tileDom.getElementsByClassName('auction_cinema__image__spinner_box')[0],

    };

    tile.getHeight = () => tileDom.offsetHeight
    tile.setImageContainerHeightRedesign = (height) => tile.domWrapper.imageContainerElement().style.height = `${height}px`
    tile.setImageContainerWidth = (width) => tile.domWrapper.imageContainerElement().style.width = `${width}px`

    tile.getTrackingData = () => {
        return JSON.parse(tileDom.getAttribute('data-tracking'));
    };

    tile.getVariationId = () => {
        return tileDom.getAttribute('data-variation-id');
    }
    tile.update = (width, adjustHeightAndKeepResolution) => {
        resize(width, adjustHeightAndKeepResolution);
    };

    tile.isWithinContainerViewport = () => {
        const containerBounds = tileDom.closest(".auction_cinema__container").getBoundingClientRect();
        const tileBounds = tileDom.getBoundingClientRect();
        return tileBounds.right > containerBounds.left && tileBounds.left < containerBounds.right;
    }

    const removeLoaderBoxElement = () => {
        let loaderBoxElement = tile.domWrapper.loaderBoxElement();
        if (loaderBoxElement) {
            tile.domWrapper.imageContainerElement().removeChild(loaderBoxElement);
        }
    };

    tile.lazyLoad = () => {
        return new Promise((resolve, reject) => {
            if (tile.domWrapper.articleImagePlaceholderElement()) {
                tile.domWrapper.addLoaderClass();
                justlazy.lazyLoad(
                    tile.domWrapper.articleImagePlaceholderElement(),
                    {
                        onloadCallback: () => {
                            removeLoaderBoxElement();
                            resolve('Successfully loaded image.');
                        },
                        onerrorCallback: () => {
                            removeLoaderBoxElement();
                            reject('Failed to load image.');
                        }
                    }
                );
            } else {
                resolve('Image already loaded');
            }
        }).then(() => tile.domWrapper.articleImageElement().clientHeight);
    };

    tile.registerOnClickHandler = (handler) => {
        tile.domWrapper.adsLinkElement().addEventListener('click', handler);
        tile.domWrapper.adsLinkElement().addEventListener('auxclick', handler);
    };

    tile.setImageContainerHeight = (height) => {
        const imageContainer = tile.domWrapper.imageContainerElement();
        imageContainer.style.minHeight = `${height}px`;
    };

    const resize = (width, adjustHeightAndKeepResolution) => {
        const articleImage = tile.domWrapper.articleImageElement();
        if (articleImage) {
            articleImage.style.height = '';
        }
        if (adjustHeightAndKeepResolution) {
            const height = 4 / 3 * width;
            tile.setImageContainerHeightRedesign(height)
        }
        tile.domWrapper.setWidth(width);
    };

    return tile;
};